<div class="dropdown-content-wrapper">
    <div class="tooltipWrapper" #tooltip [hidden]="true">
      <mpro-tooltip [options]="tooltipOptions"></mpro-tooltip>
    </div>
    <div class="sections-wrapper">
      <div class="section-wrapper">
        <div class="section">
          <ng-container *ngFor="let g of systemGroups">
            <mpro-dropdown-item class="system-group"
                                [bgColor]="getGroupColor(g, 100)"
                                [bgColorHover]="getGroupColor(g, 300)"
                                [isDropdown]="!!g.subgroups.length"
                                [leftText]="g.compactDisplayValue()"
                                [middleText]="g.name"
                                [disabled]="g.disabled || !!g.authDisabled"
                                [showLock]="!!g.authDisabled"
                                (itemClicked)="onGroupClicked(g, false)"
                                (arrowClicked)="groupArrowClicked(g, $event)"
                                [selected]="isGroupSelected(g)"
                                [dropdownOpen]="g.opened"></mpro-dropdown-item>
            <ng-container *ngIf="g.opened">
              <mpro-dropdown-item *ngFor="let sg of g.subgroups"
                                  class="system-subgroup"
                                  [bgColor]="getGroupColor(sg, 100)"
                                  [bgColorHover]="getGroupColor(sg, 300)"
                                  [leftText]="sg.compactDisplayValue()"
                                  [middleText]="sg.name"
                                  [disabled]="sg.disabled || !!sg.authDisabled"
                                  [showLock]="!!sg.authDisabled"
                                  (itemClicked)="onGroupClicked(sg, true)"
                                  (mouseenter)="showTooltip($event.target, sg)"
                                  (mouseleave)="hideTooltip()"
                                  [selected]="isGroupSelected(sg)"></mpro-dropdown-item>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
